type Category = {
	name: string;
	color: string;
	id: string;
};

const staticCategories: Category[] = [
	{ name: 'Restaurant', color: '#ffb583', id: '5fc3902fe5cc6a1cd5785fe2' },
	{ name: 'Chiropractor', color: '#e4c83b', id: '5fc3902fe5cc6a1cd5785fe4' },
	{ name: 'Clothing', color: '#0039a1', id: '5fc3902fe5cc6a1cd5785fe3' },
	{ name: 'Laundry', color: '#121770', id: '5fc3902fe5cc6a1cd5785fe5' },
	{ name: 'Fitness', color: '#8e75ef', id: '5fc3902fe5cc6a1cd5785fe7' },
	{ name: 'Beauty', color: '#79c346', id: '5fc3902fe5cc6a1cd5785fe6' },
	{ name: 'Coffee', color: '#9f007c', id: '5fc3902fe5cc6a1cd5785fe9' },
	{ name: 'Medical', color: '#01d5ab', id: '5fc3902fe5cc6a1cd5785fea' },
	{ name: 'Event', color: '#47be54', id: '5fc3902fe5cc6a1cd5785fe8' },
	{ name: 'Bars', color: '#f159b6', id: '5fc3902fe5cc6a1cd5785feb' },
	{ name: 'Auto', color: '#00742a', id: '5fc3902fe5cc6a1cd5785fec' },
	{ name: 'Grocery', color: '#5a0042', id: '5fc3902fe5cc6a1cd5785fef' },
	{ name: 'Liquor', color: '#be54c4', id: '5fc3902fe5cc6a1cd5785fed' },
	{ name: 'Child', color: '#a1e49f', id: '5fc3902fe5cc6a1cd5785fee' },
	{ name: 'Dance', color: '#e5d574', id: '5fc3902fe5cc6a1cd5785ff0' },
	{ name: 'Insurance', color: '#271c58', id: '5fc3902fe5cc6a1cd5785ff5' },
	{ name: 'Hardware', color: '#ffc064', id: '5fc3902fe5cc6a1cd5785ff4' },
	{ name: 'Nutrition', color: '#00428e', id: '5fc3902fe5cc6a1cd5785ff1' },
	{ name: 'Dry Cleaning', color: '#e88328', id: '5fc3902fe5cc6a1cd5785ff2' },
	{ name: 'Hair', color: '#005bb1', id: '5fc3902fe5cc6a1cd5785ff3' },
	{ name: 'Pet', color: '#de2f5e', id: '5fc3902fe5cc6a1cd5785ffa' },
	{ name: 'Shipping', color: '#019474', id: '5fc3902fe5cc6a1cd5785ff9' },
	{ name: 'Martial Arts', color: '#877600', id: '5fc3902fe5cc6a1cd5785ff6' },
	{ name: 'Dentist', color: '#99b5ff', id: '5fc3902fe5cc6a1cd5785ff7' },
	{ name: 'Nail', color: '#9e0017', id: '5fc3902fe5cc6a1cd5785ff8' },
	{ name: 'Storage', color: '#9168a8', id: '5fc3902fe5cc6a1cd5785ffe' },
	{ name: 'Gym', color: '#ff796d', id: '5fc3902fe5cc6a1cd5785fff' },
	{ name: 'Tanning', color: '#7b4300', id: '5fc3902fe5cc6a1cd5785ffd' },
	{ name: 'Shoes', color: '#ff6db2', id: '5fc3902fe5cc6a1cd5785ffc' },
	{ name: 'Real Estate', color: '#006a3a', id: '5fc3902fe5cc6a1cd5785ffb' },
	{ name: 'Other', color: '#fcb80d', id: '5fc3902fe5cc6a1cd5786004' },
	{ name: 'Yoga', color: '#a7547f', id: '5fc3902fe5cc6a1cd5786003' },
	{ name: 'School', color: '#ff9591', id: '5fc3902fe5cc6a1cd5786001' },
	{ name: 'Sports', color: '#900048', id: '5fc3902fe5cc6a1cd5786002' },
	{ name: 'Karate', color: '#570400', id: '5fc3902fe5cc6a1cd5786000' },
	{ name: 'Finance', color: '#2196f3', id: '6022542f8060ad4c905ef219' },
	{ name: 'Home services', color: '#795339', id: '6022546d8060ad4c905ef21a' },
	{ name: 'Vape', color: '#7562ff', id: '605073f4ebe8a0c3ffb9acac' },
	{ name: 'Barbershop', color: '#92a500', id: '6050741bebe8a0c3ffb9acad' }
];

export const useCategoriesData = () => {
	return { categories: staticCategories };
};
